import * as yup from "yup";
import { useQuery } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";
import { CHARTSMART_PLAN } from "../../consts/ChartSmart";

const planSchema = yup.object({
  limit: yup.number().required().nullable(),
  price: yup.number().required().nullable(),
});

const responseSchema = yup.object({
  chartSmartLimit: yup.string().nullable(),
  chartSmartPlan: yup.string().nullable(),
  chartSmartPlans: yup
    .object({
      starter: planSchema,
      pro: planSchema,
      unlimited: planSchema,
      payg: planSchema,
    })
    .nullable(),
  chartSmartUsed: yup.string().nullable(),
  isChartSmartPlanEnabled: yup.boolean().required(),
});

const composeResponse = (res) => {
  const data = res?.data?.data;

  return {
    chartSmartLimit: data?.chart_smart_limit
      ? String(data.chart_smart_limit)
      : null,
    chartSmartPlan: data?.chart_smart_plan || null,
    chartSmartPlans: data?.chart_smart_plans || null,
    chartSmartUsed: data?.chart_smart_usedchart_smart_used || null,
    isChartSmartPlanEnabled: Object.values(CHARTSMART_PLAN).includes(
      data?.chart_smart_plan,
    ),
  };
};

export function useSubscriptionDetailsQuery() {
  return useQuery({
    queryKey: [QUERY_KEYS.subscriptionDetail],
    queryFn: async () => {
      const res = await http.get(
        HTTP_ENDPOINTS.chartSmart.getSubscriptionDetails(),
      );
      return responseSchema.validateSync(composeResponse(res), {
        strict: true,
      });
    },
  });
}
